<template>
  <div
    v-if="pageLoading"
    class="m-3"
  >
    <placeholder-content :is-load="true" />
  </div>
  <div
    class="m-3"
    v-else-if="!hasPermission"
  >
    <access-denied/>
  </div>
  <div
    v-else
  >
    <div class="d-flex justify-content-between border-bottom mb-3">
      <ul class="nav nav-custom">
        <li
          class="nav-item"
          v-for="viewpoint in viewpoints"
        >
          <a
            class="nav-link"
            :class="params.viewpoint == viewpoint.value? 'active': ''"
            @click="setViewpoint(viewpoint.value)"
          >
            {{ $t(viewpoint.text) }}
            <span
              class="badge rounded-pill"
              :class="[viewpoint.bgc]"
            >
              {{ viewpoint.count }}
            </span>
          </a>
        </li>
      </ul>
      <column-toggle
        :headers="allHeaders"
        storage-key="users.columns"
        v-model="visibleColumns"
      />
    </div>
    <div class="d-flex justify-content-start mx-3 flex-column flex-sm-row">
      <div class="custom-input-group input-group input-group-sm me-sm-2 mb-3 w-auto">
        <input
          type="search"
          class="form-control"
          :placeholder="$t('search')+'...'"
          aria-label="Search"
          aria-describedby="search-addon"
          v-model.trim="params.search"
          @keyup.enter="fetchData"
        >
        <button
          class="input-group-text"
          type="button"
          @click="fetchData"
        >
          <i class="fas fa-search" />
        </button>
      </div>
      <per-page
        @per-page="setPerPage"
      />
    </div>
    <vue3-easy-data-table
      v-model:server-options="datatable.serverOptions"
      ref="dataTable"
      :headers="visibleHeaders"
      :items="datatable.items"
      :loading="datatable.loading"
      :server-items-length="datatable.total"
      :theme-color="'#515151'"
      :hide-footer="false"
      :hide-rows-per-page="true"
      :empty-message="$t('No Available Data')"
      :table-min-height="null"
      buttons-pagination
      :body-item-class-name="bodyItemClassNameFunction"
      table-class-name='customize-table'
    >
      <template #header-created_by="header">
        <span class="w-100 text-end">
          {{ header.text }}
        </span>
      </template>
      <template #item-avatar="item">
        <div
          class="bg-light rounded-circle d-flex align-items-center justify-content-center border"
          style="width: 35px; height: 35px;"
        >
          <i class="fa-solid fa-user text-secondary"></i>
        </div>
        <!-- <img
          v-if="item.thumbnail_url && item.image_url"
          class="img-table"
          :src="item.thumbnail_url"
          @click="showImage(item.image_url)"
          style="cursor: pointer;"
        >
        <img
          v-else
          :src="$storeIndex.getImageSrc('')"
          width="25px"
          height="25px"
        > -->
      </template>
      <template #item-email="item">
        {{ item.email || '-' }}
      </template>
      <template #item-fullname="item">
        {{ $t(item.fullname) }}<br>
        <span
          class="text-secondary"
        >
          {{ item.role }}
        </span>
      </template>
      <template #item-state="item">
        <span
          :class="['badge', viewpoints.find((viewpoint) => viewpoint.text == item.state).bgc]"
        >
          {{ $t(item.state) }}
        </span>
      </template>
      <template #item-created_at="item">
        {{ formatDateTime(item.created_at) }}
      </template>
      <template #item-action="item">
        <div
          class="icon-link custom-actions"
        >
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['Pending'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-success btn-sm btn-icon"
              @click="() => {
                offcanvasFrom.open = true;
                offcanvasFrom.id = item.id;
                offcanvasFrom.type = 'APPROVE';
              }"
            >
              <i class="fa-solid fa-check"/>
            </button>
            <template #content>
              <div>{{ $t('Approve') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['Pending'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-title="Custom popover"
              data-bs-content="This popover is themed via CSS variables."
              class="btn btn-danger btn-sm btn-icon"
              @click="handleReject(item.id)"
            >
              <i class="fa-solid fa-xmark" />
            </button>
            <template #content>
              <div>{{ $t('Reject') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['Accept', 'Blocked'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-icon btn-sm btn-warning text-white"
              @click="() => {
                offcanvasFrom.open = true;
                offcanvasFrom.id = item.id;
                offcanvasFrom.type = 'MANAGE';
              }"
            >
              <i class="fa-solid fa-pen" />
            </button>
            <template #content>
              <div>{{ $t('Manage') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['Accept'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-secondary btn-icon btn-sm text-white"
              @click="handleBlock(item.id, item.fullname)"
            >
              <i class="fa-solid fa-ban" />
            </button>
            <template #content>
              <div>{{ $t('Block') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['Blocked'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-secondary btn-icon btn-sm text-white"
              @click="handleUnblock(item.id, item.fullname)"
            >
              <i class="fa-solid fa-unlock" />
            </button>
            <template #content>
              <div>{{ $t('Unblock') }}</div>
            </template>
          </popper>
          <!--
            รีเซ็ตรหัสผ่าน — Owner เท่านั้น และรีเซ็ตให้ Owner ไม่ได้ (api/docs/password-reset.md)
            BE บังคับกติกาเดียวกันอีกชั้น (OwnerOnlyMiddleware + DetailMiddleware) ตรงนี้แค่ซ่อนปุ่มให้ไม่รก
          -->
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="isOwner && ['Accept'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-info btn-sm btn-icon text-white"
              @click="handleResetPassword(item.id, item.fullname)"
            >
              <i class="fa-solid fa-key" />
            </button>
            <template #content>
              <div>{{ $t('Reset Password') }}</div>
            </template>
          </popper>
          <popper
            :placement="'top'"
            :hover="true"
            :arrow="true"
            :disableClickAway="true"
            class="popper-default border-0 m-0"
            v-if="['Accept', 'Blocked'].includes(item.state) && !item.owner"
          >
            <button
              type="button"
              data-bs-toggle="popover"
              data-bs-placement="top"
              class="btn btn-danger btn-sm btn-icon"
              @click="handleDelete(item.id, item.fullname)"
            >
              <i class="fa-solid fa-trash-can" />
            </button>
            <template #content>
              <div>{{ $t('Delete') }}</div>
            </template>
          </popper>
        </div>
      </template>
      <template #loading>
        <i class="fa-solid fa-spinner fa-spin fa-2xl" />
      </template>
    </vue3-easy-data-table>
    <offcanvas-info
      v-if="viewInfo.open"
      :id="viewInfo.id"
      @close-info="closeInfo"
    />
    <offcanvas-form
      v-if="offcanvasFrom.open"
      :id="offcanvasFrom.id"
      :type="offcanvasFrom.type"
      @close="closeForm"
    />
    <div
      class="modal fade"
      id="modalImage"
      ref="modalImage"
      aria-labelledby="modalImageLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <img
          :src="modalImage.image"
          class="d-block w-100"
          data-bs-dismiss="modal"
        >
      </div>
    </div>

    <!--
      รหัสชั่วคราวหลังรีเซ็ต — โชว์ครั้งเดียวจริง ๆ (api/docs/password-reset.md §3 ข้อ 4)
      DB เก็บแค่ hash ไม่มี endpoint ไหนอ่านย้อนได้ ปิดหน้าต่างนี้แล้วต้องกดรีเซ็ตใหม่
    -->
    <div
      class="modal fade"
      id="modalTempPassword"
      ref="modalTempPassword"
      data-bs-backdrop="static"
      aria-labelledby="modalTempPasswordLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" style="max-width: 400px;">
        <div class="modal-content border-0 rounded-4 shadow">
          <div class="modal-body p-4 text-center">
            <div
              class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
              style="width: 60px; height: 60px; background-color: rgba(13, 202, 240, .12);"
            >
              <i class="fa-solid fa-key fs-4 text-info" />
            </div>

            <h5 class="fw-bold mb-2" id="modalTempPasswordLabel">
              {{ $t('Temporary Password') }}
            </h5>
            <p class="text-muted small mb-4">
              {{ $t('Give this password to') }}
              <strong class="text-dark">{{ tempPassword.fullname }}</strong>
              <span
                v-if="tempPassword.username"
                class="text-muted font-monospace"
              >· {{ tempPassword.username }}</span>
            </p>

            <!-- กล่องรหัส: เส้นประ = สื่อว่าเป็นของชั่วคราว ฉีกทิ้งหลังใช้ -->
            <div
              class="d-flex align-items-center rounded-3 ps-3 pe-2 py-2 mb-2"
              style="border: 1.5px dashed #ced4da; background-color: #f8f9fa; cursor: pointer;"
              @click="copyTempPassword"
            >
              <input
                type="text"
                class="form-control border-0 bg-transparent shadow-none text-center fw-bold font-monospace p-0"
                style="font-size: 1.3rem; letter-spacing: .08em;"
                :value="tempPassword.password"
                readonly
                ref="tempPasswordInput"
                @focus="$event.target.select()"
              >
              <button
                class="btn btn-sm border-0 flex-shrink-0"
                :class="tempPassword.copied ? 'text-success' : 'text-secondary'"
                type="button"
                @click.stop="copyTempPassword"
              >
                <i class="fa-regular fs-5" :class="tempPassword.copied ? 'fa-circle-check' : 'fa-copy'" />
              </button>
            </div>
            <div
              class="small mb-4"
              :class="tempPassword.copied ? 'text-success fw-bold' : 'text-muted'"
            >
              <i
                class="fa-solid me-1"
                :class="tempPassword.copied ? 'fa-check' : 'fa-hand-pointer'"
              />
              {{ tempPassword.copied ? $t('Copied') : $t('Click to copy') }}
            </div>

            <div
              class="d-flex text-start rounded-3 p-3 mb-4"
              style="background-color: rgba(255, 193, 7, .12);"
            >
              <i class="fa-solid fa-triangle-exclamation text-warning mt-1 me-2" />
              <div style="font-size: 13px;" class="text-dark">
                <div class="fw-bold mb-1">
                  {{ $t('This password is shown only once - it cannot be viewed again') }}
                </div>
                <div class="text-muted">
                  {{ $t('They will be asked to set their own password at the next login') }}
                </div>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-theme text-white fw-bold w-100 py-2"
              data-bs-dismiss="modal"
            >
              {{ $t('I have saved it') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import AccessDenied from "@/plugins/AccessDenied.vue";
import Vue3EasyDataTable from 'vue3-easy-data-table';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import PerPage from '@/plugins/PerPage.vue';
import FieldsDef from "./assets/template/datatable/FieldsDef";
import OffcanvasInfo from "./OffcanvasInfo.vue";
import OffcanvasForm from "./OffcanvasForm.vue";
import ColumnToggle from '@/components/shared/ColumnToggle.vue';
import { loadVisibleColumns } from '@/utils/columnToggle';
import { Users } from '@/services/endpoint/users.service';
import { useAuthStore } from '@/stores/auth.store';
import moment from "moment";
import numeral from 'numeral';
import Popper from "vue3-popper";

export default {
  data() {
    return {
      hasPermission: false,
      params: {
        limit: 10,
        page: 1,
        search: '',
        viewpoint: 'pending'
      },
      viewInfo: {
        open: false,
        id: 0,
      },
      offcanvasFrom: {
        open: false,
        type: 'APPROVE',
        id: 0
      },
      pageLoading: false,
      datatable: {
        loading: false,
        headers: FieldsDef,
        items: [],
        total: 0,
        serverOptions: {
          page: 1,
          rowsPerPage: 10
        }
      },
      viewpoints: [
        {
          value: 'pending',
          text: 'Pending',
          count: 0,
          bgc: 'bg-warning text-dark'
        },
        {
          value: 'accept',
          text: 'Accept',
          count: 0,
          bgc: 'badge bg-success'
        },
        {
          value: 'blocked',
          text: 'Blocked',
          count: 0,
          bgc: 'badge bg-secondary'
        }
      ],
      modalImage: {
        open: false,
        image: ''
      },
      tempPassword: {
        fullname: '',
        username: '',
        password: '',
        copied: false
      },
      visibleColumns: loadVisibleColumns('users.columns', FieldsDef(t => t))
    }
  },
  components: {
    AccessDenied,
    PlaceholderContent,
    PerPage,
    Vue3EasyDataTable,
    OffcanvasInfo,
    OffcanvasForm,
    ColumnToggle,
    Popper
  },
  computed: {
    // สิทธิ์รีเซ็ตรหัสผ่านผูกกับ is_owner ไม่ใช่ permission (api/docs/password-reset.md §3.1)
    isOwner() {
      return !!useAuthStore().user?.is_owner;
    },
    allHeaders() {
      return this.datatable.headers(this.$t);
    },
    visibleHeaders() {
      return this.allHeaders.filter(h => !h.togglable || this.visibleColumns.includes(h.value));
    }
  },
  async mounted() {
    this.pageLoading = true;
    // store persist ข้ามการ deploy — คนที่ล็อกอินค้างไว้ก่อนอัปเดตยังไม่มี is_owner ในนั้น
    await useAuthStore().ensureUserField('is_owner');
    await this.fetchData();
    this.pageLoading = false;
  },
  methods: {
    closeInfo() {
      this.viewInfo.open = false;
    },
    closeForm() {
      this.offcanvasFrom.open = false;
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    bodyItemClassNameFunction(column, rowNumber) {
      let className = 'align-top py-1 px-2';
      const columnCenter = ['image'];
      const columnEnd = ['price', 'created_by'];
      if (columnCenter.includes(column)) {
        className += ' text-center';
      }
      if (columnEnd.includes(column)) {
        className += ' text-end';
      }
      return className;
    },
    async setViewpoint(tab) {
      if (this.params.viewpoint == tab) return;
      this.params.viewpoint = tab;
      await this.fetchData();
    },
    async fetchData() {
      this.datatable.loading = true;
      var queryString = '?' + $.param(this.params);
      await Users.list(queryString).then(res => {
        this.datatable.items = res.data.data;
        this.datatable.total = res.data.meta.total;
        this.viewpoints.forEach(viewpoint => {
          viewpoint.count = res.data.viewpoint_cnt[viewpoint.value];
        });
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.pageLoading = false;
        }
      });

      this.datatable.loading = false;
      return;
    },
    setPerPage(perPage) {
      this.params.limit = perPage;
      this.$refs.dataTable.updateRowsPerPageActiveOption(perPage);
      this.fetchData();
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    async handleDelete(id, fullname) {
      try {
        let self = this;
        let title = this.$t("Delete User") + '?';
        let html = this.$t("You are about to delete") + `<br><strong>"${fullname}"</strong>.<br><small style="color:red">` + this.$t('This action cannot be undone') + `!</small>`;
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Yes, delete it!");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-secondary me-2",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          reverseButtons: true,
          preConfirm: async function () {
            return Users.delete(id)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Delete Product Success!'));
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleBlock(id, fullname) {
      try {
        let self = this;
        let title = this.$t("Block User Access") + '?';
        let html = this.$t("Are you sure you want to block") + `<br><strong>"${fullname}"</strong>`;
        let confirmButtonText = this.$t("Yes, Block User");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-secondary me-2",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          reverseButtons: true,
          preConfirm: async function () {
            return Users.block(id)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Block Success!'));
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleUnblock(id, fullname) {
      try {
        let self = this;
        let title = this.$t("Restore User Access") + '?';
        let html = this.$t("Are you sure you want to unblock") + `<br><strong>"${fullname}"</strong>`;
        let confirmButtonText = this.$t("Yes, Unblock User");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success me-2",
            cancelButton: "btn btn-secondary",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Users.unblock(id)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Block Success!'));
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    async handleReject(id) {
      try {
        let self = this;
        let title = this.$t("Are you sure you want to reject") + '?';
        let html = this.$t("This action will permanently delete the registration request. This cannot be undone.");
        let confirmButtonText =
          '<i class="fas fa-check-circle me-1"></i>' + this.$t("Confirm");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          // text: "You will not be able to undo this action.",
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary me-2",
            cancelButton: "btn btn-danger",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async function () {
            return Users.reject(id)
              .then((response) => {
                self.fetchData();
                self.$toast.success("<B>" + self.$t('Success') + "</B>\n" + self.$t('Reject Success!'));
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
              })
          },
        });
      } catch (error) {
      }
    },
    /**
     * Owner รีเซ็ตรหัสผ่านให้พนักงานที่ลืมรหัส (api/docs/password-reset.md)
     *
     * ระบบไม่มี SMS/email จึงไม่มี OTP — คนยืนยันตัวตนคือ Owner ที่เห็นหน้าพนักงานในร้าน
     * แล้วส่งรหัสชั่วคราวให้ต่อหน้า
     */
    async handleResetPassword(id, fullname) {
      try {
        let self = this;
        let title = this.$t("Reset Password") + '?';
        let html = this.$t("A new temporary password will be generated for")
          + `<br><strong>"${fullname}"</strong><br><small class="text-muted">`
          + this.$t("Their current password and all active sessions will stop working immediately")
          + `</small>`;
        let confirmButtonText = '<i class="fas fa-key me-1"></i>' + this.$t("Yes, Reset Password");
        this.$swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: title,
          html: html,
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: confirmButtonText,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-info text-white",
            cancelButton: "btn btn-secondary me-2",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          reverseButtons: true,
          preConfirm: async function () {
            return Users.resetPassword(id)
              .then((response) => {
                const data = response.data.data;
                self.tempPassword = {
                  fullname: data.fullname,
                  username: data.username,
                  password: data.temporary_password,
                  copied: false
                };
                self.fetchData();
                return true;
              })
              .catch((error) => {
                if (error?.response?.status === 403) {
                  self.$swal.update({
                    title: self.$t('Access Denied'),
                    confirmButtonText: '<i class="fas fa-redo me-1"></i>' + self.$t("Try again"),
                    text: self.$t('You do not have permission to access this page.')
                  });
                  self.$swal.showValidationMessage(
                    self.$t(error?.response?.data?.message)
                  )
                } else {
                  self.$toast.warn(error?.response?.data?.message);
                }
                return false;
              })
          },
        }).then((result) => {
          // เปิด modal หลัง swal ปิดสนิทแล้วเท่านั้น ไม่งั้น backdrop สองชั้นทับกันจนคลิกไม่ได้
          // (app/docs/CONVENTIONS.md §3)
          if (result.isConfirmed && result.value) {
            $(this.$refs.modalTempPassword).modal('show');
          }
        });
      } catch (error) {
      }
    },
    async copyTempPassword() {
      try {
        await navigator.clipboard.writeText(this.tempPassword.password);
      } catch (err) {
        // clipboard API ใช้ได้เฉพาะ https/localhost — ร้านที่เปิดผ่าน http ต้องตกมาทางนี้
        const input = this.$refs.tempPasswordInput;
        input.select();
        document.execCommand('copy');
      }
      this.tempPassword.copied = true;
    },
    async showImage(image) {
      this.modalImage.image = image;
      $(this.$refs.modalImage).modal('show');
    }
  },
  watch: {
    "datatable.serverOptions" (nval, oval) {
      delete this.params.sort;
      this.params.page = nval.page;
      this.params.limit = nval.rowsPerPage;
      if (nval.sortBy && nval.sortType) this.params.sort = nval.sortBy + "|" + nval.sortType;
      this.fetchData();
    }
  }
}
</script>
